<template>
  <v-container fluid class="px-0">
    <v-skeleton-loader v-if="!isDataLoaded" type="image"></v-skeleton-loader>
    <div v-if="isDataLoaded && filteredBanners.length > 0">
      <VueSlickCarousel
          v-bind="settings"
          :centerPadding="($vuetify.breakpoint.sm || $vuetify.breakpoint.xs) ? '20px' : '100px'"
          class="center-carousel"
          ref="carousel"
          >
          <div v-for="(banner, i) in filteredBanners" :key="i">
              <div v-for="(sizeImg, key) in banner.imgUrl.es" :key="key">
                  <a v-if="banner.link" @click="redirectTo(banner.link)">
                      <v-img :src="sizeImg" v-if="key == 'sm'" :class="`d-md-none d-${key}-block`" width="100%"></v-img>
                      <v-img :src="sizeImg" v-if="key == 'md'" :class="`d-none d-${key}-block d-lg-none`" width="100%"></v-img>
                      <v-img :src="sizeImg" v-if="key == 'lg'" :class="`d-none d-${key}-block`" width="100%"></v-img>
                  </a>
                  <div v-else>
                    <v-img :src="sizeImg" v-if="key == 'sm'" :class="`d-md-none d-${key}-block`" width="100%"></v-img>
                    <v-img :src="sizeImg" v-if="key == 'md'" :class="`d-none d-${key}-block d-lg-none`" width="100%"></v-img>
                    <v-img :src="sizeImg" v-if="key == 'lg'" :class="`d-none d-${key}-block`" width="100%"></v-img>
                  </div>
              </div>
          </div>
      </VueSlickCarousel>
    </div>
  </v-container>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

import AnalyticEventsMixin from "../../mixins/analyticEvents"
import { AnalyticEventTypes } from '@/constants/AnalyticEventTypes'

export default {
  components: {
    VueSlickCarousel,
  },
  mixins: [AnalyticEventsMixin],
  data() {
    return {
        settings: {
            arrows: true,
            centerMode: true,
            dots: true,
            focusOnSelect: true,
            infinite: true,
            slidesToShow: 1,
            speed: 500
        },
        bannersData: null,
        isDataLoaded: false,
    }
  },
  computed: {
      filteredBanners() {
          return this.bannersData && this.bannersData.banners
          ? this.bannersData.banners.filter(banner => banner.platform === 'students' && banner.section === 'store')
          : [];
      }
  },
  mounted() {
    this.createAnalyticEvent(AnalyticEventTypes.GoToStore)

    const url = 'https://s3.us-east-2.amazonaws.com/beereaders.com/marketing/banners.json';

    fetch(url)
      .then(response => {
          if (!response.ok) {
              throw new Error(`Error al obtener el archivo. Código de estado: ${response.status}`);
          }
          return response.json();
      })
      .then(data => {
          this.bannersData = data;
          this.isDataLoaded = true;
      })
      .catch(error => {
          console.error(error.message);
      });
  },
  methods: {
    redirectTo(link) {
      if (link) window.open(link, '_blank')
    },
    showRight() {
      this.$refs.carousel.next()
    },
    showLeft() {
      this.$refs.carousel.prev()
    },
  }
}
</script>

<style lang="scss">
.center-carousel.slick-initialized {
  .slick-slide{
    padding: 0 12px;
    @media screen and (max-width: 600px) {
      padding: 0 5px;
    }
  }
  .slick-dots{
    li {
      margin: 0;
      button:before{
        color: #7764CA;
        font-size: 12px;
        @media screen and (max-width: 960px) {
          font-size: 8px;
        }
      }
    }
  }
  .slick-prev, .slick-next{
    height: 44px;
    width: 44px;
    z-index: 1;
    @media screen and (max-width: 960px) {
      display: none!important;
    }
  }
  .slick-next{
    right: 25px;
    &::before{
      content: "\F0B2A";
      color: white;
      font-family: "Material Design Icons";
      font-size: 44px;
    }
  }
  .slick-prev{
    left: 25px;
    &::before{
      content: "\F0B28";
      color: white;
      font-family: "Material Design Icons";
      font-size: 44px;
    }
  }
}
</style>